import _createForOfIteratorHelper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module list/listproperties/liststylecommand
 */
import { Command } from 'ckeditor5/src/core.js';
import { first } from 'ckeditor5/src/utils.js';
import { expandListBlocksToCompleteList, isListItemBlock } from '../list/utils/model.js';
import { getListTypeFromListStyleType } from './utils/style.js';
/**
 * The list style command. It changes `listStyle` attribute of the selected list items,
 * letting the user choose styles for the list item markers.
 * It is used by the {@link module:list/listproperties~ListProperties list properties feature}.
 */
var ListStyleCommand = /*#__PURE__*/function (_Command) {
  _inherits(ListStyleCommand, _Command);
  var _super = _createSuper(ListStyleCommand);
  /**
   * Creates an instance of the command.
   *
   * @param editor The editor instance.
   * @param defaultType The list type that will be used by default if the value was not specified during
   * the command execution.
   * @param supportedTypes The list of supported style types by this command.
   */
  function ListStyleCommand(editor, defaultType, supportedTypes) {
    var _this;
    _classCallCheck(this, ListStyleCommand);
    _this = _super.call(this, editor);
    _this.defaultType = defaultType;
    _this._supportedTypes = supportedTypes;
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(ListStyleCommand, [{
    key: "refresh",
    value: function refresh() {
      this.value = this._getValue();
      this.isEnabled = this._checkEnabled();
    }
    /**
     * Executes the command.
     *
     * @fires execute
     * @param options.type The type of the list style, e.g. `'disc'` or `'square'`. If `null` is specified, the default
     * style will be applied.
     */
  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var model = this.editor.model;
      var document = model.document;
      model.change(function (writer) {
        _this2._tryToConvertItemsToList(options);
        var blocks = Array.from(document.selection.getSelectedBlocks()).filter(function (block) {
          return block.hasAttribute('listType');
        });
        if (!blocks.length) {
          return;
        }
        blocks = expandListBlocksToCompleteList(blocks);
        var _iterator = _createForOfIteratorHelper(blocks),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var block = _step.value;
            writer.setAttribute('listStyle', options.type || _this2.defaultType, block);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
    /**
     * Checks if the given style type is supported by this plugin.
     */
  }, {
    key: "isStyleTypeSupported",
    value: function isStyleTypeSupported(value) {
      if (!this._supportedTypes) {
        return true;
      }
      return this._supportedTypes.includes(value);
    }
    /**
     * Checks the command's {@link #value}.
     *
     * @returns The current value.
     */
  }, {
    key: "_getValue",
    value: function _getValue() {
      var listItem = first(this.editor.model.document.selection.getSelectedBlocks());
      if (isListItemBlock(listItem)) {
        return listItem.getAttribute('listStyle');
      }
      return null;
    }
    /**
     * Checks whether the command can be enabled in the current context.
     *
     * @returns Whether the command should be enabled.
     */
  }, {
    key: "_checkEnabled",
    value: function _checkEnabled() {
      var editor = this.editor;
      var numberedList = editor.commands.get('numberedList');
      var bulletedList = editor.commands.get('bulletedList');
      return numberedList.isEnabled || bulletedList.isEnabled;
    }
    /**
     * Check if the provided list style is valid. Also change the selection to a list if it's not set yet.
     *
     * @param options.type The type of the list style. If `null` is specified, the function does nothing.
    */
  }, {
    key: "_tryToConvertItemsToList",
    value: function _tryToConvertItemsToList(options) {
      if (!options.type) {
        return;
      }
      var listType = getListTypeFromListStyleType(options.type);
      if (!listType) {
        return;
      }
      var editor = this.editor;
      var commandName = "".concat(listType, "List");
      var command = editor.commands.get(commandName);
      if (!command.value) {
        editor.execute(commandName);
      }
    }
  }]);
  return ListStyleCommand;
}(Command);
export { ListStyleCommand as default };